import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AreaSimulacao from "../components/simulacao/AreaSimulacao";
import "../styles.scss";
import ClientHeader from "~components/ClientInfo/ClientHeader";
import useCliente from "~/fetchs/useCliente";
import { useConfigureFooter } from "~hooks/useHelpers";
import useSimulacao from "~/fetchs/useSimulacao";

const Simulations = ({ hideHeader, novaSimulacao = false }) => {

  const [manualIdSimulacao, setManualIdSimulacao] = useState(null);
  const { removeProduto, quantidadeProduto, setEdit, desconto, simulacao, loading, changeFracionamentoDescargaManual, getClienteId } = useSimulacao(novaSimulacao, manualIdSimulacao);
  const simulador = { removeProduto, quantidadeProduto, setEdit, desconto, changeFracionamentoDescargaManual, simulacao, getClienteId };

  useConfigureFooter(
    { form: simulacao?.gruposProduto?.length > 0, formId: "simulacao", submitLabel: "Salvar Simulação", notDeveloped: false },
    [simulacao]
  );

  const { parameter: idCliente, simulacaoId } = useParams();
  const { cliente } = useCliente(idCliente);


  return (
    <div>
      {!hideHeader && <ClientHeader dados={cliente} />}

      <AreaSimulacao
        cliente={cliente}
        simulacao={simulacao}
        simulador={simulador}
        isLoading={loading}
        desconto={desconto}
        setManualIdSimulacao={setManualIdSimulacao}
      />
    </div>
  );
};

export default Simulations;
